import { ISubCategoryContext, IFilterValues } from './subCategoryContext';

export enum SubCategoryActionTypes {
	SET_SUBCATEGORIES = 'SET_SUBCATEGORIES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	TOGGLE_SUB_CATEGORY_IS_HIDDEN = 'TOGGLE_SUB_CATEGORY_IS_HIDDEN',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetSubcategories {
	type: SubCategoryActionTypes.SET_SUBCATEGORIES;
	payload: {
		subCategories: ISubCategoryContext['subCategories'];
		typeOfModalWindow: ISubCategoryContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: SubCategoryActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: ISubCategoryContext['searchString'];
	};
}

interface ISetIDCustomer {
	type: SubCategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ISubCategoryContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: SubCategoryActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: ISubCategoryContext['IDSelectedRestaurant'];
	};
}

interface ISetIDCategory {
	type: SubCategoryActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: ISubCategoryContext['IDSelectedCategory'];
	};
}

interface IResetSelectedControls {
	type: SubCategoryActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: SubCategoryActionTypes.SET_SORT_BY;
	payload: {
		sortBy: ISubCategoryContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: SubCategoryActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: ISubCategoryContext['countOfItems'];
	};
}

interface IToggleSubCategoryIsHidden {
	type: SubCategoryActionTypes.TOGGLE_SUB_CATEGORY_IS_HIDDEN;
}

interface IChangeCurrentPage {
	type: SubCategoryActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: ISubCategoryContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: SubCategoryActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: ISubCategoryContext['IDForDeletion'];
		typeOfModalWindow: ISubCategoryContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: SubCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ISubCategoryContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: SubCategoryActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TSubCategoryAction =
	| ISetSubcategories
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDCategory
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IToggleSubCategoryIsHidden
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
